import React from 'react';

interface DataLoadingScopeSelectorProps {
  selectedScope: 'county' | 'region' | 'california';
  onScopeChange: (scope: 'county' | 'region' | 'california') => void;
  disabled?: boolean;
}

const DataLoadingScopeSelector: React.FC<DataLoadingScopeSelectorProps> = ({
  selectedScope,
  onScopeChange,
  disabled = false
}) => {
  const scopeOptions = [
    { value: 'county', label: 'Load County Data', description: 'Fastest - County only' },
    { value: 'region', label: 'Load Regional Data', description: 'Medium - County + Region' },
    { value: 'california', label: 'Load All California', description: 'Complete - Full state data' }
  ];

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <label style={{ 
        fontSize: '14px', 
        fontWeight: '500', 
        color: '#333',
        whiteSpace: 'nowrap'
      }}>
        Data Scope:
      </label>
      <select
        value={selectedScope}
        onChange={(e) => onScopeChange(e.target.value as 'county' | 'region' | 'california')}
        disabled={disabled}
        style={{
          padding: '6px 12px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          fontSize: '14px',
          backgroundColor: disabled ? '#f5f5f5' : 'white',
          color: disabled ? '#999' : '#333',
          cursor: disabled ? 'not-allowed' : 'pointer',
          minWidth: '180px'
        }}
        title={scopeOptions.find(opt => opt.value === selectedScope)?.description}
      >
        {scopeOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DataLoadingScopeSelector;
